<div style="text-align: center">
<h1 class="text-danger">Error 403</h1>
<br />
<h2 class="text-danger">  
You are not Authorized to view this page!  
</h2>
</div>